<template>
  <div class="relative h-screen w-screen">

    <BaseIcon class="absolute z-10 mt-11 ml-11 h-8 text-white" name="logo"/>

    <img alt="error image" class="absolute inset-0 -z-10 h-screen w-screen object-cover" src="/img/404.jpg">

    <svg class="absolute inset-0 -z-10 h-screen object-cover"
         preserveAspectRatio="xMinYMax"
         style="color: #42307D"
         viewBox="0 0 492.9 596.4"
         xmlns="http://www.w3.org/2000/svg">
      <path d="M469.8 596.4c16-37.6 23-79.4 23.1-121.7.1-176.3-119.4-270.3-267.4-244.7L466.2 0H0v596.4h469.8z"
            fill="currentColor"></path>
    </svg>

    <div class="absolute bottom-1/4 left-11 w-max">
      <h1 class="mb-4 text-4xl font-bold uppercase text-neutral-100">Perdido?</h1>
      <p class="">
        Não foi possível encontrar a página
      </p>
      <p>
        Contactar o suporte através de
        <a class="text-neutral-100" href="mailto:support@3cket.com">support@3cket.com</a>
      </p>
    </div>

    <!--      <BaseButton @click="handleError">-->
    <!--        Navigate home-->
    <!--      </BaseButton>-->
    <!--      <br>-->
    <!--      <NuxtLink :to="localePath('/')">-->
    <!--        Navigate home 2-->
    <!--      </NuxtLink>-->
  </div>
</template>

<script lang="ts" setup>
import BaseIcon from "~/components/base/BaseIcon.vue";

const localePath = useLocalePath()

const handleError = () => clearError().then(() => navigateTo(localePath('/'), {replace: true}))
</script>
